import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UserManagement from '../pages/modules/admin/UserManagement';
import TopUpRequest from '../pages/modules/admin/TopUpRequest';
import AllTransaction from '../pages/modules/admin/AllTransaction';
import PendingTransaction from '../pages/modules/admin/PendingTransaction';
import LiveTransaction from '../pages/modules/admin/LiveTransaction';
import SearchTransaction from '../pages/modules/admin/SearchTransaction';
import CronTransaction from '../pages/modules/admin/CronTransaction';
import RetailerApproval from '../pages/modules/admin/RetailerApproval';
import RetailerApprovalForm from '../pages/modules/admin/RetailerApprovalForm';
import AllTransactions from '../pages/modules/admin/reports/AllTransactions';
import UserwiseLedger from '../pages/modules/admin/reports/UserwiseLedger';
import TopUpHistory from '../pages/modules/admin/reports/TopUpHistory';
import PayinReports from '../pages/modules/admin/reports/PayinReports';
import TdsReports from '../pages/modules/admin/reports/TdsReports';
import CommissionReports from '../pages/modules/admin/reports/CommissionReports';
import SummaryReports from '../pages/modules/admin/reports/SummaryReports';
import RSM from '../pages/modules/admin/salesforce/RSM';
import ASM from '../pages/modules/admin/salesforce/ASM';
import TSM from '../pages/modules/admin/salesforce/TSM';
import TransactionBi from '../pages/modules/admin/dashboard/TransactionBi';
import MapwiseBi from '../pages/modules/admin/dashboard/MapwiseBi';
import ProductwiseBi from '../pages/modules/admin/dashboard/ProductwiseBi';
import Services from '../pages/modules/admin/settings/Services';
import Operators from '../pages/modules/admin/settings/Operators';
import LowBalanceAlert from '../pages/modules/admin/settings/LowBalanceAlert';
import Notification from '../pages/modules/admin/settings/Notification';
import ErrorLog from '../pages/modules/admin/settings/ErrorLog';
import BankMaster from '../pages/modules/admin/settings/BankMaster';
import Beneficiaries from '../pages/modules/admin/settings/Beneficiaries';
import PayoutBeneficiaries from '../pages/modules/admin/settings/PayoutBeneficiaries';
import LoginIPs from '../pages/modules/admin/settings/LoginIPs';
import APIProviderList from '../pages/modules/admin/APIProviderList';
import APIProviderCommission from '../pages/modules/admin/APIProviderCommission';
import DeviceOrder from '../pages/modules/admin/DeviceOrder';
import CircleWiseSwitching from '../pages/modules/admin/switching/CircleWiseSwitching';
import UserWiseSwitching from '../pages/modules/admin/switching/UserWiseSwitching';
import RandomSwitching from '../pages/modules/admin/switching/RandomSwitching';
import DenominationSwitch from '../pages/modules/admin/switching/DenominationSwitch';
import FailureSwitching from '../pages/modules/admin/switching/FailureSwitching';
import PendingSwitching from '../pages/modules/admin/switching/PendingSwitching';
import MyProfile from '../pages/profile/MyProfile';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard/transaction-bi" replace />} />
      <Route path="/dashboard" element={<Navigate to="/dashboard/transaction-bi" replace />} />
      <Route path="/dashboard/transaction-bi" element={<TransactionBi />} />
      <Route path="/dashboard/mapwise-bi" element={<MapwiseBi />} />
      <Route path="/dashboard/productwise-bi" element={<ProductwiseBi />} />
      <Route path="/user-management/super-distributor" element={<UserManagement />} />
      <Route path="/user-management/master-distributor" element={<UserManagement />} />
      <Route path="/user-management/distributor" element={<UserManagement />} />
      <Route path="/user-management/retailer" element={<UserManagement />} />
      <Route path="/user-management/api-partner" element={<UserManagement />} />
      <Route path="/user-management/sales-force" element={<UserManagement />} />
      <Route path="/user-management/support" element={<UserManagement />} />
      <Route path="/user-management/retailer-approval" element={<RetailerApproval />} />
      <Route path="/user-management/retailer-approval-form/:id" element={<RetailerApprovalForm />} />
      <Route path="/top-up-request" element={<TopUpRequest />} />
      <Route path="/transaction/all" element={<AllTransaction />} />
      <Route path="/transaction/pending" element={<PendingTransaction />} />
      <Route path="/transaction/live" element={<LiveTransaction />} />
      <Route path="/transaction/search" element={<SearchTransaction />} />
      <Route path="/transaction/cron" element={<CronTransaction />} />
      <Route path="/reports/summary-reports" element={<SummaryReports />} />
      <Route path="/reports/all-transactions" element={<AllTransactions />} />
      <Route path="/reports/userwise-ledger" element={<UserwiseLedger />} />
      <Route path="/reports/top-up-history" element={<TopUpHistory />} />
      <Route path="/reports/payin-reports" element={<PayinReports />} />
      <Route path="/reports/tds-reports" element={<TdsReports />} />
      <Route path="/reports/commission-reports" element={<CommissionReports />} />
      <Route path="/sales-force/rsm" element={<RSM />} />
      <Route path="/sales-force/asm" element={<ASM />} />
      <Route path="/sales-force/tsm" element={<TSM />} />
      <Route path="/settings/services" element={<Services />} />
      <Route path="/settings/operators" element={<Operators />} />
      <Route path="/settings/low-balance-alert" element={<LowBalanceAlert />} />
      <Route path="/settings/notification" element={<Notification />} />
      <Route path="/settings/error-log" element={<ErrorLog />} />
      <Route path="/settings/bank-master" element={<BankMaster />} />
      <Route path="/settings/beneficiaries" element={<Beneficiaries />} />
      <Route path="/settings/payout-beneficiaries" element={<PayoutBeneficiaries />} />
      <Route path="/settings/login-ips" element={<LoginIPs />} />
      <Route path="/api-provider/list" element={<APIProviderList />} />
      <Route path="/api-provider/commission" element={<APIProviderCommission />} />
      <Route path="/device-order" element={<DeviceOrder />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="/switching/userwise" element={<UserWiseSwitching />} />
      <Route path="/switching/random" element={<RandomSwitching />} />
      <Route path="/switching/denomination" element={<DenominationSwitch />} />
      <Route path="/switching/failure" element={<FailureSwitching />} />
      <Route path="/switching/pending" element={<PendingSwitching />} />
      <Route path="/switching/circle-wise" element={<CircleWiseSwitching />} />
      <Route path="*" element={<Navigate to="/user-management/super-distributor" replace />} />
    </Routes>
  );
};

export default AdminRoutes;

